import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import Dialog from 'components/Dialog';

const Drawer = dynamic(() => import('./Drawer'), { ssr: false });

const Modal = dynamic(() => import('./Modal'), { ssr: false });

const GA_EVENT_CATEGORY = 'login_modal_v5';

const LoginDialog = ({ isMyBlackFridayGamePage = false, ...props }) => (
  <Dialog
    drawer={Drawer}
    gaEventCategory={GA_EVENT_CATEGORY}
    isMyBlackFridayGamePage={isMyBlackFridayGamePage}
    modal={Modal}
    {...props}
  />
);

LoginDialog.propTypes = {
  isMyBlackFridayGamePage: PropTypes.bool,
};

export default LoginDialog;
